import React from "react"
import PropTypes from "prop-types"
import Container from "../Container"
import { Row, Col } from "antd"

import { useI18next } from "gatsby-plugin-react-i18next"
import Logo from "../../images/lembaga-pendidikan.png"
import LogoRetina from "../../images/lembaga-pendidikan@2x.png"
import FooterWidget from "./FooterWidget"

import "./Footer.less"

function FooterBottom(props) {
  const { t } = useI18next()
  return (
    <div className="footer-section">
      <FooterWidget />
      <Container>
        <Row gutter={40} justify="space-between">
          <Col span={24} md={18}>
            <Row gutter={30} style={{ flexFlow: "row" }}>
              <Col>
                <img
                  src={Logo}
                  srcSet={`${LogoRetina} 2x`}
                  alt="Lembaga Pengelola Dana Pendidikan"
                />
              </Col>
              <Col flex="auto">
                <h3 className="logo-title">
                  {t("Lembaga Pengelola Dana Pendidikan")}
                </h3>
                <p>
                  {t(
                    "Gedung Danadyaksa Cikini, Jalan Cikini Raya No.91A-D, Menteng, Jakarta Pusat 10330"
                  )}
                </p>

                <div className="hide-mobile">
                  <h3
                    className="footer-title"
                    style={{ marginTop: 30, marginBottom: 8 }}
                  >
                    {t("Website Kementerian Keuangan Lainnya")}
                  </h3>
                  <div className="footer-site">
                    {props.otherWebsite.map(function (item, index) {
                      return (
                        <a
                          key={index}
                          href={item.url}
                          rel="noopener noreferrer"
                          target="_blank"
                        >
                          {(index ? " | " : "") + item.text}
                        </a>
                      )
                    })}
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
          <Col span={24} md={5}>
            <div
              className="show-mobile text-center"
              style={{ marginBottom: 20 }}
            >
              <h3
                className="footer-title"
                style={{ marginTop: 30, marginBottom: 8 }}
              >
                {t("Website Kementerian Keuangan Lainnya")}
              </h3>
              <div className="footer-site">
                {props.otherWebsite.map(function (item, index) {
                  return (
                    <a
                      key={index}
                      href={item.url}
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      {(index ? " | " : "") + item.text}
                    </a>
                  )
                })}
              </div>
            </div>

            <div className="footer-meta-links">
              <h3 className="footer-title">{t("Ikuti Kami")}</h3>
              <Row align="center" gutter={20}>
                {props.socialLink.map(function (item, i) {
                  return (
                    <Col flex="auto" key={i}>
                      <a
                        href={item.url}
                        rel="noopener noreferrer"
                        target="_blank"
                      >
                        {item.icon}
                      </a>
                    </Col>
                  )
                })}
              </Row>

              <div style={{ margin: "40px 0" }} />

              <h3 className="footer-title" style={{ marginBottom: 4 }}>
                {t("Saran dan Pengaduan")}
              </h3>
              <a
                href="//www.wise.kemenkeu.go.id"
                rel="noopener noreferrer"
                target="_blank"
                style={{ color: "inherit" }}
              >
                wise.kemenkeu.go.id
              </a>

              <div style={{ margin: "20px 0" }} />

              <h3 className="footer-title" style={{ marginBottom: 4 }}>
                {t("Informasi dan Bantuan")}
              </h3>
              <a
                href="//bantuan.lpdp.kemenkeu.go.id"
                rel="noopener noreferrer"
                target="_blank"
                style={{ color: "inherit" }}
              >
                bantuan.lpdp.kemenkeu.go.id
              </a>
			  <br />
			  <a
                href="//chat.botika.online/yvcXvYd"
                rel="noopener noreferrer"
                target="_blank"
                style={{ color: "inherit" }}
              >
                Customer Service Online
              </a>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

FooterBottom.prototypes = {
  otherWebsite: PropTypes.shape({
    text: PropTypes.string,
    url: PropTypes.string,
  }),
  socialLink: PropTypes.shape({
    icon: PropTypes.node,
    url: PropTypes.string,
  }),
}

FooterBottom.defautltProps = {
  otherWebsite: [],
  socialLink: [],
}

export default FooterBottom
